import React from "react";
import { IconError, IconCheckCircle } from "../Icons";
import Chip from "@material-ui/core/Chip";
import withStyles from "@material-ui/core/styles/withStyles";

const style = theme => ({
  error: {
    background: theme.palette.error.main
  },
  success: {
    background: "#689F38",
    color: "#fff",
  }
});

const MsgError1 = ({ msg, classes }) => (
  <Chip
    icon={<IconError style={{marginLeft: 6}}/>} 
    label={msg}
    color="secondary"
    className={classes.error}
  />
);
const MsgError = withStyles(style)(MsgError1);

const MsgSuccess1 = ({ msg, classes }) => (
  <Chip
    icon={<IconCheckCircle style={{marginLeft: 6}}/>}
    label={msg}
    className={classes.success}
    color="primary"
  />
);
const MsgSuccess = withStyles(style)(MsgSuccess1);

export { MsgError, MsgSuccess };
